// @ts-nocheck
import fecha from 'fecha';

export const formatDate = date => {
  // Override fecha.i18n to support any language
  fecha.i18n = {
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'],
    dayNames: 'Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado'.split('_'),
    monthNamesShort: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    monthNames: [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ],
    amPm: ['am', 'pm'],
    // D is the day of the month, function returns something like...  3rd or 11th
    DoFn(D) {
      return (
        D +
        ['th', 'st', 'nd', 'rd'][
          D % 10 > 3 ? 0 : ((D - (D % 10) !== 10) * D) % 10 // eslint-disable-line
        ]
      );
    },
  };

  const dayAndMonth = 'dddd DD [de] MMMM';
  // const minutesAndHours = 'h:mma [hrs.]';
  const minutesAndHours = 'HH:mm';

  fecha.masks.dayAndMonth = dayAndMonth;
  fecha.masks.minutesAndHours = minutesAndHours;

  const dateToFormat = typeof date === 'string' ? new Date(date) : date;

  return {
    dayAndMonth: fecha.format(dateToFormat, 'dayAndMonth'),
    minutesAndHours: fecha.format(dateToFormat, 'minutesAndHours'),
  };
};
